import React from 'react';
import { styled } from '@mui/material/styles';
import { Box, Button, CircularProgress } from '@mui/material';
import { useTranslation } from 'react-i18next';

const PREFIX = 'EntityTitle';

const classes = {
  container: `${PREFIX}-container`,
  title: `${PREFIX}-title`,
  logo: `${PREFIX}-logo`,
  button: `${PREFIX}-button`,
};

const StyledBox = styled(Box)(() => ({
  [`&.${classes.container}`]: {
    display: 'flex',
    alignItems: 'flex-start',
  },

  [`& .${classes.title}`]: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    flexGrow: 1,
  },

  [`& .${classes.logo}`]: {
    height: 50,
  },

  [`& .${classes.button}`]: {
    alignSelf: 'flex-end',
  },
}));

interface EntityTitleProps {
  icon: React.ReactNode;
  label: string | undefined;
  loading: boolean;
  readOnly: boolean;
  logo?: string;
  onEdit: () => void;
}

export default function EntityTitle({
  icon,
  label,
  loading,
  readOnly,
  logo,
  onEdit,
}: EntityTitleProps) {
  const { t } = useTranslation('common');

  return (
    <StyledBox className={classes.container}>
      <Box className={classes.title}>
        {logo ? null : icon}
        {loading ? <CircularProgress /> : label}
        {logo && !loading ? (
          <img className={classes.logo} src={logo} alt="logo" />
        ) : null}
      </Box>
      {loading || readOnly ? null : (
        <Button variant="contained" color="primary" onClick={onEdit}>
          {t('common.edit')}
        </Button>
      )}
    </StyledBox>
  );
}
